import { Component, AfterViewInit, Input} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { AssetShipment } from '../../models/entities/asset-shipment';
import { AssetShipmentService } from '../../services/asset-shimpnent.service';
import { AssetShipmentPipe } from '../../pipes/asset-shipment-pipe';

@Component({
    selector: 'asset-shipment-widget',
    templateUrl: './asset-shipment-widget.component.html',
    styleUrls: ['./asset-shipment-widget.component.scss']
})


export class AssetShipmentWidgetComponent extends BaseWidget implements AfterViewInit {

  assetShipment             : AssetShipment = new AssetShipment();
  branchs                   : Branch[]        = null;

  @Input() assetAssignmentsColumns   : [];
  @Input() assetShipmentAssetsColumns: [];


  expeditionForecastDate      : Date;
  

  constructor(
      protected controlTablesService  : ControlTablesService,
      protected assetShipmentService  : AssetShipmentService,
      protected toastr                : ToastrService,
      protected leanUtilsService      : LeanUtilsService) {
      super(toastr, leanUtilsService);
  }


//---------------------------------------------------------------------------------------
  ngOnInit(){    
    super.ngOnInit();         
    this.controlTablesService.branchsGet().then(branchs => {
      this.branchs = branchs; 
    }) 
    
    // New Asset Shipment case
    //------------------------------------------------------------------
    if (this.assetShipment.inserted) {
        this.assetShipment.branch = new Branch();
    }
    //------------------------------------------------------------------

  }
//---------------------------------------------------------------------------------------


 //--------------------------------------------------------------------------------------------------------
 setEntity(assetShipment: AssetShipment) {
      this.assetShipment  = { ...assetShipment };
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.assetShipment;
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  saveRow() : Promise<AssetShipment>{
      return this.assetShipmentService.assetShipmentSave(this.assetShipment);
  }
//--------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
assetTransferPipe  : AssetShipmentPipe = new AssetShipmentPipe();
getAssetShipmentStatus() : string{
  return this.assetTransferPipe.transform(this.assetShipment, 'progressLevel');
}
//---------------------------------------------------------------------------------------



//---------------------------------------------------------------------------------------
assetShipmentProcess(action : string){

}
//---------------------------------------------------------------------------------------

}
